import createModel, { prop } from './lib/create_model';

const TeamAssistV2Turn = createModel({
  modelName: 'TeamAssistV2Turn',

  properties: {
    id: prop(String).isRequired,
    question: prop(String),
    // A quick action's label, shown in place of the message it sent.
    displayedMessage: prop(String),
    // The conversation the agent was viewing when asking.
    conversationId: prop(String),
    answer: prop(Object).default(null),
    live: prop(Boolean).default(false),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default TeamAssistV2Turn;
